import { RemoveSnackbarNotificationReducer } from './types';

export const removeSnackbarNotificationReducer: RemoveSnackbarNotificationReducer =
  (state, action) => {
    const { key } = action.payload;

    return {
      ...state,
      notifications: state.notifications.filter(
        (notification) => notification.key !== key
      ),
    };
  };
